module.exports = __webpack_public_path__ + "static/img/adress3.f06a6c5.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/index/adress3.png
// module id = yxab
// module chunks = 0